import * as React from "react";
let ignoreNextPopstateCount = 0;
export function pushNestedDialogLevel() {
    window.history.pushState({ ...window.history.state, nestedDialogLevel: true }, "");
}
export function replaceNestedDialogLevel() {
    window.history.replaceState({ ...window.history.state, nestedDialogLevel: true }, "");
}
export function popNestedDialogLevel(count = 1) {
    if (count <= 0)
        return;
    ignoreNextPopstateCount++;
    window.history.go(-count);
}
export function useNestedDialogBackButton(active, onBack) {
    const activeRef = React.useRef(active);
    activeRef.current = active;
    const onBackRef = React.useRef(onBack);
    onBackRef.current = onBack;
    React.useEffect(() => {
        const handlePopState = () => {
            if (ignoreNextPopstateCount > 0) {
                ignoreNextPopstateCount--;
                return;
            }
            if (!activeRef.current)
                return;
            onBackRef.current();
        };
        window.addEventListener("popstate", handlePopState);
        return () => window.removeEventListener("popstate", handlePopState);
    }, []);
}
